module.exports = __webpack_public_path__ + "static/img/image_placeholder_squared.a17ad7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image_placeholder_squared.jpg
// module id = 1587
// module chunks = 31